// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 5.99792C7.00112 3.23745 9.23927 1 12 1C14.7607 1 16.9989 3.23745 17 5.99792H7Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.41421 8L5 6.58579V4H3V7.41421L6 10.4142V12H3V14H6V15.5858L3 18.5858V22H5V19.4142L6.36064 18.0536C7.08903 20.0533 8.8508 21.5565 11 21.917V8H6.41421Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 8V21.917C15.1492 21.5565 16.911 20.0533 17.6394 18.0536L19 19.4142V22H21V18.5858L18 15.5858V14H21V12H18V10.4142L21 7.41421V4H19V6.58579L17.5858 8H13Z"}}]};

const BugFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bug-filled',
    ref,
    icon: element,
  },
));

BugFilledIcon.displayName = 'BugFilledIcon';

export default BugFilledIcon;
